<template lang="pug">
  ListLayout(
    :title='$route.meta.title'
  )
    ItemList(
      type='tracks'
      view='list'
      :empty-message='$l10n("LIST_DONT_HAVE_TRACKS")'
      :items='favoriteTracks'
      :tracklist='tracklist'
      :params='params'
      :pagination='pagination'
    )
</template>

<script>
import PageLoader from "@/services/pageLoader";
import Helpers from "@/services/helpers";
import paginationPage from "@/mixins/pages/pagination.mixin";
import errorHandler from "@/services/errorHandler";

import { mapGetters } from "vuex";

const strategy = async function(route, ctx) {
  try {
    const params = {
      page: 1,
      ...route.query,
      ...(route.meta.params || {})
    };

    const {
      tracks = [],
      pagination = null
    } = await PageLoader.getFavoriteTracks(params);

    ctx.tracksIds = tracks.map(item => item.id);
    ctx.pagination = pagination;
    ctx.params = params;
  } catch (error) {
    errorHandler.add(error);
  }
};

export default {
  name: "FavoriteTracksPage",
  mixins: [paginationPage(strategy)],
  data() {
    return {
      tracksIds: [],
      params: {}
    };
  },
  computed: {
    ...mapGetters({
      tracks: "tracks/tracks"
    }),
    tracklist() {
      return {
        id: Helpers.getTracklistId(this.tracksIds),
        tracks: this.tracksIds
      };
    },
    favoriteTracks() {
      return this.tracksIds.map(id => this.tracks[id]);
    }
  }
};
</script>
